import FloatingCard from '../../../components/general/FloatingCard';
import SubmitDiscrepancyReportDialog from '../../../components/dialogs/SubmitDiscrepancyReportDialog';
import VehicleModuleVersionsDialog from '../../../components/dialogs/VehicleModuleVersionsDialog';
import { en } from '../../../locales/en';
import { useDialogQueueStore } from '../../../store/useDialogQueueStore';
import type { VehicleId } from '../../../types/gcs/vehicle';
import type { MenuItemTileProps } from '../../../components/general/MenuItemTile';
import VehiclePanelHeader from './VehiclePanelHeader';
import { McErrorTile } from './McErrorTile';
import { MissionStepper } from './MissionStepper';

interface EmptyVehiclePanelProps {
  vehicleId: VehicleId;
  gcsId: string;
  onClose: () => void;
  onFocusVehicle: () => void;
}

function EmptyVehiclePanel({ vehicleId, gcsId, onClose, onFocusVehicle }: EmptyVehiclePanelProps) {
  const { showDialog, hideDialog } = useDialogQueueStore();

  const menuItems: MenuItemTileProps[] = [
    {
      label: en.vehiclePanelMenuItems.showVersions,
      onClick: () => {
        showDialog({
          id: `vehicle-module-versions-${vehicleId}`,
          component: <VehicleModuleVersionsDialog vehicleId={vehicleId} onClose={hideDialog} />
        });
      }
    },
    {
      label: en.vehiclePanelMenuItems.discrepancyReport,
      onClick: () => {
        showDialog({
          id: 'submit-discrepancy-report',
          component: <SubmitDiscrepancyReportDialog gcsId={gcsId} vehicleId={vehicleId} onClose={hideDialog} />
        });
      }
    }
  ];

  return (
    <FloatingCard>
      <VehiclePanelHeader
        vehicleId={vehicleId}
        gcsId={gcsId}
        onFocusVehicle={onFocusVehicle}
        onClose={onClose}
        menuItems={menuItems}
      />
      <McErrorTile gcsId={gcsId} vehicleId={vehicleId} />
      <MissionStepper gcsId={gcsId} vehicleId={vehicleId} />
    </FloatingCard>
  );
}

export default EmptyVehiclePanel;
